import _Image2 from "element-ui/lib/theme-chalk/image.css";
import "element-ui/lib/theme-chalk/base.css";
import _Image from "element-ui/lib/image";
import "/Users/gentlecoder/njzq/cls-pc/node_modules/core-js/modules/es.array.iterator.js";
import "/Users/gentlecoder/njzq/cls-pc/node_modules/core-js/modules/es.promise.js";
import "/Users/gentlecoder/njzq/cls-pc/node_modules/core-js/modules/es.object.assign.js";
import "/Users/gentlecoder/njzq/cls-pc/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from './App.vue';
import './style/main.scss';
import { router } from './router';
import Loading from './directives/loading/loading';
import './iframeResizer.contentWindow.js';
Vue.config.productionTip = false;
Vue.directive('loading', Loading);
Vue.use(_Image);
new Vue({
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');